<template>
  <v-fab-transition>
    <v-btn
      v-show="visible"
      :style="style"
      fab
      fixed
      bottom
      right
      dark
      :small="isMobile"
      :color="colors.secondary"
      @click="scrollToTop"
    >
      <v-icon>expand_less</v-icon>
    </v-btn>
  </v-fab-transition>
</template>

<script>
import colors from '@/utils/colors';

export default {
  name: 'scroll-to-top',
  props: {
    isMobile: { type: Boolean },
    offsetTop: { type: Number },
  },
  data: () => ({
    colors,
  }),
  methods: {
    scrollToTop() {
      this.$vuetify.goTo(0);
    },
  },
  computed: {
    style() {
      return {
        marginBottom: this.isMobile ? '56px' : undefined,
      };
    },
    visible() {
      return this.offsetTop >= 20;
    },
  },
};
</script>
